<!-- Overlay backdrop -->
<div class="mobile-menu__backdrop" (click)="onBackdropClick()" aria-hidden="true"></div>

<!-- Slide-in panel -->
<aside
  class="mobile-menu__panel"
  role="dialog"
  aria-modal="true"
  aria-label="Navigation menu"
  (click)="onPanelClick($event)"
>
  <!-- Header with close button -->
  <div class="mobile-menu__header">
    <button class="mobile-menu__close" (click)="closeMenu.emit()" aria-label="Close menu">
      <rt-icon name="close" />
    </button>
  </div>

  <!-- Navigation section -->
  <nav class="mobile-menu__section">
    <h3 class="mobile-menu__section-title">Navigation</h3>
    <ul class="mobile-menu__nav-list">
      @for (item of mainNavItems; track item.id) {
        <li>
          <button
            class="mobile-menu__nav-item"
            [class.mobile-menu__nav-item--active]="activeMainTab() === item.id"
            (click)="onMainTabClick(item.id)"
          >
            {{ item.label }}
            @if (activeMainTab() === item.id) {
              <span class="mobile-menu__nav-indicator"></span>
            }
          </button>
        </li>
      }
    </ul>
  </nav>

  <!-- Product filters section -->
  <div class="mobile-menu__section">
    <h3 class="mobile-menu__section-title">Filter by product</h3>
    <div class="mobile-menu__chips">
      @for (tab of productTabs; track tab.id) {
        <button
          class="mobile-menu__chip"
          [class.mobile-menu__chip--active]="activeProductTab() === tab.id"
          (click)="onProductTabClick(tab.id)"
        >
          {{ tab.label }}
        </button>
      }
    </div>
  </div>

  <!-- Settings section -->
  <div class="mobile-menu__section">
    <h3 class="mobile-menu__section-title">Settings</h3>

    <!-- Language selector -->
    <div class="mobile-menu__setting">
      <label class="mobile-menu__setting-label" for="mobile-language-select">Language</label>
      <select
        id="mobile-language-select"
        class="mobile-menu__select"
        [value]="currentLocale()"
        (change)="onLocaleChange($event)"
      >
        @for (locale of availableLocales(); track locale) {
          <option [value]="locale">{{ getLanguageLabel(locale) }}</option>
        }
      </select>
    </div>

    <!-- Theme toggle -->
    <div class="mobile-menu__setting">
      <span class="mobile-menu__setting-label">Theme</span>
      <button class="mobile-menu__theme-toggle" (click)="onThemeToggle()">
        <rt-icon [name]="isDarkMode() ? 'dark' : 'light'" />
        <span>{{ isDarkMode() ? 'Dark' : 'Light' }}</span>
      </button>
    </div>
  </div>

  <!-- Feedback link -->
  <div class="mobile-menu__footer">
    <rt-button variant="outline" size="medium" class="mobile-menu__feedback">
      Give feedback
    </rt-button>
  </div>
</aside>
